module.exports = __webpack_public_path__ + "static/media/right-arrow-white-sm.6a048f11.svg";